module.exports = "/images/role-founder-ceo-icon.svg?0e59abc3d27adf852196baef1a945b7a";